import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { deepMix } from '@antv/util';
import { subObject } from '../utils/helper';
import { Tree as TreeTransform } from '../data/tree';
import { maybeAnimation, subTooltip } from '../utils/mark';
var DEFAULT_LAYOUT_OPTIONS = {
  sortBy: function sortBy(a, b) {
    return b.value - a.value;
  }
};
var DEFAULT_NODE_OPTIONS = {
  axis: false,
  legend: false,
  type: 'point',
  encode: {
    x: 'x',
    y: 'y',
    size: 2,
    shape: 'point'
  }
};
var DEFAULT_LINK_OPTIONS = {
  type: 'link',
  encode: {
    x: 'x',
    y: 'y',
    shape: 'smooth'
  }
};
var DEFAULT_LABEL_OPTIONS = {
  text: '',
  fontSize: 10
};
export var Tree = function Tree(options) {
  var data = options.data,
    _options$encode = options.encode,
    encode = _options$encode === void 0 ? {} : _options$encode,
    _options$scale = options.scale,
    scale = _options$scale === void 0 ? {} : _options$scale,
    _options$style = options.style,
    style = _options$style === void 0 ? {} : _options$style,
    _options$layout = options.layout,
    layout = _options$layout === void 0 ? {} : _options$layout,
    _options$nodeLabels = options.nodeLabels,
    nodeLabels = _options$nodeLabels === void 0 ? [] : _options$nodeLabels,
    _options$linkLabels = options.linkLabels,
    linkLabels = _options$linkLabels === void 0 ? [] : _options$linkLabels,
    _options$animate = options.animate,
    animate = _options$animate === void 0 ? {} : _options$animate,
    _options$tooltip = options.tooltip,
    tooltip = _options$tooltip === void 0 ? {} : _options$tooltip;
  var valueEncode = encode === null || encode === void 0 ? void 0 : encode.value;
  var _TreeTransform = TreeTransform(Object.assign(Object.assign(Object.assign({}, DEFAULT_LAYOUT_OPTIONS), layout), {
      field: valueEncode
    }))(data),
    nodes = _TreeTransform.nodes,
    edges = _TreeTransform.edges;
  var nodeTooltip = subTooltip(tooltip, 'node', {
    title: 'name',
    items: ['value']
  }, true);
  var linkTooltip = subTooltip(tooltip, 'link', {
    title: '',
    items: [function (d) {
      return {
        name: 'source',
        value: d.source.name
      };
    }, function (d) {
      return {
        name: 'target',
        value: d.target.name
      };
    }]
  });
  return [deepMix({}, DEFAULT_LINK_OPTIONS, {
    data: edges,
    encode: subObject(encode, 'link'),
    scale: subObject(scale, 'link'),
    labels: linkLabels,
    style: Object.assign({
      stroke: '#999'
    }, subObject(style, 'link')),
    tooltip: linkTooltip,
    animate: maybeAnimation(animate, 'link')
  }), deepMix({}, DEFAULT_NODE_OPTIONS, {
    data: nodes,
    scale: subObject(scale, 'node'),
    encode: subObject(encode, 'node'),
    labels: [Object.assign(Object.assign({}, DEFAULT_LABEL_OPTIONS), subObject(style, 'label'))].concat(_toConsumableArray(nodeLabels)),
    style: Object.assign({}, subObject(style, 'node')),
    tooltip: nodeTooltip,
    animate: maybeAnimation(animate, 'node')
  })];
};
Tree.props = {};